import omit from 'ramda/es/omit';

import { APPS2_SUCCESS } from 'app/actions/apps/apps';
import { SUB_PAUSE_RESUME_SUCCESS, SUB_STOP_SUCCESS, SUB_EDIT_SUCCESS } from 'app/actions/apps/subs';
import { SUB_PAY_SUCCESS } from 'app/actions/apps/subs/pay';
import { SUB_PREPAYD_SUCCESS } from 'app/actions/apps/subs/prepayd';
import { SUBSCRIBE_BUNDLE_SUCCESS } from 'app/actions/apps/subs/bundle';
// import { APP_SUBSCRIBE_SUCCESS } from 'app/actions/apps/subscribe';

const defaultState = {
  // данные подписок
  // [id]: {}
  // ...
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case APPS2_SUCCESS: {
      return { ...action.payload.subs };
    }

    case SUB_STOP_SUCCESS: {
      return omit(action.payload.ids, state);
    }

    // case APP_SUBSCRIBE_SUCCESS:
    case SUB_PAUSE_RESUME_SUCCESS:
    case SUB_PAY_SUCCESS:
    case SUB_PREPAYD_SUCCESS:
    case SUBSCRIBE_BUNDLE_SUCCESS:
    case SUB_EDIT_SUCCESS: {
      return { ...state, ...action.payload.subs };
    }

    default:
  }

  return state;
}
